import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

import { iterateGroupProducts } from './iterateGroupProducts';

/**
 * Grid row count for nested sub-rows layout.
 * Multi-version products use rowspan — one grid row per version.
 *
 * @param {CzechSuklRsAtcGroupResponse} group the group to measure.
 * @returns {number} the number of grid rows the group occupies.
 */
export function countGroupGridRows(group: CzechSuklRsAtcGroupResponse): number {
	const products = iterateGroupProducts(group);

	if (products.length === 0) {
		return 1;
	}

	return products.reduce((sum, { versions }) => sum + Math.max(versions.length, 1), 0);
}
